  import React, { useEffect, useMemo, useState } from "react";
  import api from "../api";
  import {
    HiOutlineUsers,
    HiOutlineUserPlus,
    HiOutlineArrowPath,
    HiOutlineCheckCircle,
    HiOutlineXCircle,
    HiOutlinePencilSquare,
    HiOutlineKey,
    HiOutlineUserGroup,
    HiOutlineShieldCheck,
    HiOutlineFlag,
    HiOutlineBuildingOffice2,
    HiOutlineClipboardDocumentList,
    HiOutlineArrowLeft,
    HiOutlineCalendarDays,
    HiOutlineEye,
    HiOutlineEyeSlash
  } from "react-icons/hi2";

  const theme = {
    primary: "#0F766E",
    primaryDark: "#115E59",
    primaryLight: "#14B8A6",
    accent: "#2DD4BF",
    background: "#F8FAFC",
    surface: "#FFFFFF",
    surfaceSoft: "#ECFEFF",
    text: "#0F172A",
    textMuted: "#64748B",
    border: "#D1FAE5",
    borderSoft: "#E2E8F0",
    success: "#16A34A",
    warning: "#F59E0B",
    danger: "#DC2626"
  };

  const emptyUserForm = {
    id: null,
    username: "",
    name: "",
    password: "",
    emp_id: "",
    email: "",
    department: "",
    designation: "",
    role: "user",
    manager_id: ""
  };

  function AdminPanel({
    activeTab: controlledActiveTab,
    setActiveTab: controlledSetActiveTab
  }) {
    const [localActiveTab, setLocalActiveTab] = useState("dashboard");

    const activeTab = controlledActiveTab || localActiveTab;
    const setActiveTab = controlledSetActiveTab || setLocalActiveTab;

    const [stats, setStats] = useState({
      total_users: 0,
      active_users: 0,
      total_managers: 0,
      total_admins: 0,
      pending_requests: 0
    });

    const [users, setUsers] = useState([]);
    const [userSearch, setUserSearch] = useState("");
    const [editingUserId, setEditingUserId] = useState(null);
    const [userForm, setUserForm] = useState(emptyUserForm);
    const [userMessage, setUserMessage] = useState("");

    const [practice, setPractice] = useState("");
    const [department, setDepartment] = useState("");
    const [task, setTask] = useState("");
    const [taskPractice, setTaskPractice] = useState("");
    const [taskDepartment, setTaskDepartment] = useState("");

    const [targetPractice, setTargetPractice] = useState("");
    const [targetDepartment, setTargetDepartment] = useState("");
    const [targetTask, setTargetTask] = useState("");
    const [target, setTarget] = useState("");

    const [practiceSearch, setPracticeSearch] = useState("");
    const [departmentSearch, setDepartmentSearch] = useState("");
    const [taskListSearch, setTaskListSearch] = useState("");
    const [targetListSearch, setTargetListSearch] = useState("");

    const [masterMessage, setMasterMessage] = useState("");

    const [practicesList, setPracticesList] = useState([]);
    const [departmentsList, setDepartmentsList] = useState([]);
    const [tasksList, setTasksList] = useState([]);
    const [targetsList, setTargetsList] = useState([]);

    const [managers, setManagers] = useState([]);
    const [loading, setLoading] = useState(true);

    const [resetUser, setResetUser] = useState(null);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [resetPassword, setResetPassword] = useState("");
  const [confirmResetPassword, setConfirmResetPassword] = useState("");
  const [resetLoading, setResetLoading] = useState(false);
  const [resetMessage, setResetMessage] = useState("");
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [showConfirmResetPassword, setShowConfirmResetPassword] = useState(false);
  const [statusUser, setStatusUser] = useState(null);
  const [statusLoading, setStatusLoading] = useState(false);

    const loadAll = async () => {
      try {
        setLoading(true);

        const [statsRes, usersRes] = await Promise.all([
          api.get("/admin/stats"),
          api.get("/users")
        ]);

        const usersRows = usersRes.data || [];
        const statsData = statsRes.data || {};

        setStats({
          total_users: Number(statsData.total_users || 0),
          active_users: Number(statsData.active_users || 0),
          total_managers: Number(statsData.total_managers || 0),
          total_admins: Number(statsData.total_admins || 0),
          pending_requests: Number(statsData.pending_requests || 0)
        });

        setUsers(usersRows);
        setManagers(
          usersRows.filter((u) => {
            const role = String(u.role || "").toLowerCase();
            return role === "manager" || role === "admin";
          })
        );
      } catch (err) {
        console.error("Admin panel load failed:", err);
      } finally {
        setLoading(false);
      }
    };

    const loadMasters = async () => {
      try {
        const [pRes, dRes, tRes, targetRes] = await Promise.all([
          api.get("/practices"),
          api.get("/departments"),
          api.get("/tasks"),
          api.get("/targets")
        ]);

        setPracticesList(pRes.data || []);
        setDepartmentsList(dRes.data || []);
        setTasksList(tRes.data || []);
        setTargetsList(targetRes.data || []);
      } catch (err) {
        console.error("Masters load failed:", err);
        setPracticesList([]);
        setDepartmentsList([]);
        setTasksList([]);
        setTargetsList([]);
      }
    };

useEffect(() => {
  loadAll();
  loadMasters();
}, []);

    const filteredUsers = useMemo(() => {
      const q = userSearch.trim().toLowerCase();
      if (!q) return users;

      return users.filter((u) => {
        return (
          String(u.name || "").toLowerCase().includes(q) ||
          String(u.username || "").toLowerCase().includes(q) ||
          String(u.email || "").toLowerCase().includes(q) ||
          String(u.emp_id || "").toLowerCase().includes(q) ||
          String(u.role || "").toLowerCase().includes(q) ||
          String(u.department || "").toLowerCase().includes(q) ||
          String(u.designation || "").toLowerCase().includes(q)
        );
      });
    }, [users, userSearch]);

    const filteredPractices = useMemo(() => {
      const q = practiceSearch.trim().toLowerCase();
      if (!q) return practicesList;
      return practicesList.filter((item) =>
        String(item.name || "").toLowerCase().includes(q)
      );
    }, [practicesList, practiceSearch]);

    const filteredDepartments = useMemo(() => {
      const q = departmentSearch.trim().toLowerCase();
      if (!q) return departmentsList;
      return departmentsList.filter((item) =>
        String(item.name || "").toLowerCase().includes(q)
      );
    }, [departmentsList, departmentSearch]);

    const filteredTasks = useMemo(() => {
      const q = taskListSearch.trim().toLowerCase();
      if (!q) return tasksList;

      return tasksList.filter((item) => {
        return (
          String(item.name || item.task || "").toLowerCase().includes(q) ||
          String(item.practice || "").toLowerCase().includes(q) ||
          String(item.department || "").toLowerCase().includes(q)
        );
      });
    }, [tasksList, taskListSearch]);

    const filteredTargets = useMemo(() => {
      const q = targetListSearch.trim().toLowerCase();
      if (!q) return targetsList;

      return targetsList.filter((item) => {
        return (
          String(item.task || "").toLowerCase().includes(q) ||
          String(item.practice || "").toLowerCase().includes(q) ||
          String(item.department || "").toLowerCase().includes(q)
        );
      });
    }, [targetsList, targetListSearch]);

    const defaultTargets = useMemo(() => {
      return [...targetsList].sort((a, b) => {
        const pa = String(a.practice || "");
        const pb = String(b.practice || "");
        if (pa !== pb) return pa.localeCompare(pb);

        const da = String(a.department || "");
        const db = String(b.department || "");
        if (da !== db) return da.localeCompare(db);

        return String(a.task || "").localeCompare(String(b.task || ""));
      });
    }, [targetsList]);

    const activePracticesOnly = useMemo(() => {
      return practicesList.filter((item) => item.is_active !== false);
    }, [practicesList]);

    const availableTasksForTarget = useMemo(() => {
      if (!targetPractice || !targetDepartment) return [];

      return tasksList.filter((item) => {
        return (
          String(item.practice || "").toLowerCase() ===
            String(targetPractice).toLowerCase() &&
          String(item.department || "").toLowerCase() ===
            String(targetDepartment).toLowerCase()
        );
      });
    }, [tasksList, targetPractice, targetDepartment]);

    const leadershipUsers = useMemo(() => {
      return users.filter((u) => String(u.role || "").toLowerCase() === "admin");
    }, [users]);

    const managerUsers = useMemo(() => {
      return users.filter((u) => String(u.role || "").toLowerCase() === "manager");
    }, [users]);

    const employeeUsers = useMemo(() => {
      return users.filter((u) => String(u.role || "").toLowerCase() === "user");
    }, [users]);

    const employeesByManager = useMemo(() => {
      const grouped = {};
      employeeUsers.forEach((emp) => {
        const key = String(emp.manager_id || "unassigned");
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(emp);
      });

      Object.keys(grouped).forEach((key) => {
        grouped[key].sort((a, b) =>
          String(a.name || "").localeCompare(String(b.name || ""))
        );
      });

      return grouped;
    }, [employeeUsers]);

    const unassignedEmployees = useMemo(() => {
      return employeesByManager["unassigned"] || [];
    }, [employeesByManager]);

    const employeeCount = useMemo(() => {
      return users.filter((u) => String(u.role || "").toLowerCase() === "user")
        .length;
    }, [users]);

    const inactiveCount = useMemo(() => {
      return users.filter((u) => !u.is_active).length;
    }, [users]);

    const resetUserForm = () => {
      setUserForm(emptyUserForm);
      setEditingUserId(null);
    };

    const startEditUser = (row) => {
      setActiveTab("users");
      setEditingUserId(row.id);
      setUserForm({
        id: row.id,
        username: row.username || "",
        name: row.name || "",
        password: "",
        emp_id: row.emp_id || "",
        email: row.email || "",
        department: row.department || "",
        designation: row.designation || "",
        role: row.role || "user",
        manager_id: row.manager_id || ""
      });
      setUserMessage("");
    };

    const validateCreateUser = () => {
      if (!String(userForm.username || "").trim()) return "❌ Username is required";
      if (!String(userForm.name || "").trim()) return "❌ Name is required";
      if (!String(userForm.password || "").trim()) return "❌ Password is required";
      if (!String(userForm.emp_id || "").trim()) return "❌ Employee ID is required";
      if (!String(userForm.email || "").trim()) return "❌ Email is required";
      if (!String(userForm.department || "").trim()) return "❌ Department is required";
      if (!String(userForm.designation || "").trim()) return "❌ Designation is required";
      if (!String(userForm.role || "").trim()) return "❌ Role is required";
      if (
        String(userForm.role || "").toLowerCase() === "user" &&
        !String(userForm.manager_id || "").trim()
      ) {
        return "❌ Manager is required for employee";
      }
      return "";
    };

    const validateEditUser = () => {
      if (!String(userForm.username || "").trim()) return "❌ Username is required";
      if (!String(userForm.name || "").trim()) return "❌ Name is required";
      if (!String(userForm.emp_id || "").trim()) return "❌ Employee ID is required";
      if (!String(userForm.email || "").trim()) return "❌ Email is required";
      if (!String(userForm.department || "").trim()) return "❌ Department is required";
      if (!String(userForm.designation || "").trim()) return "❌ Designation is required";
      if (!String(userForm.role || "").trim()) return "❌ Role is required";
      if (
        String(userForm.role || "").toLowerCase() === "user" &&
        !String(userForm.manager_id || "").trim()
      ) {
        return "❌ Manager is required for employee";
      }
      return "";
    };

    const saveUser = async () => {
      setUserMessage("");

      const validationError = editingUserId
        ? validateEditUser()
        : validateCreateUser();

      if (validationError) {
        setUserMessage(validationError);
        return;
      }

      try {
        if (editingUserId) {
          await api.put(`/users/${editingUserId}`, {
            username: userForm.username,
            name: userForm.name,
            emp_id: userForm.emp_id,
            email: userForm.email,
            department: userForm.department,
            designation: userForm.designation,
            role: userForm.role,
            manager_id: userForm.role === "user" ? userForm.manager_id : null
          });

          await loadAll();
          setUserMessage("✅ User updated successfully");
          resetUserForm();
        } else {
          await api.post("/users", {
            username: userForm.username,
            name: userForm.name,
            password: userForm.password,
            emp_id: userForm.emp_id,
            email: userForm.email,
            department: userForm.department,
            designation: userForm.designation,
            role: userForm.role,
            manager_id: userForm.role === "user" ? userForm.manager_id : null
          });

          await loadAll();
          setUserMessage("✅ User created successfully");
          setUserForm(emptyUserForm);
        }
      } catch (err) {
        setUserMessage(err.response?.data?.error || "❌ Failed to save user");
      }
    };

  const toggleUserStatus = (row) => {
    setStatusUser(row);
  };

  const confirmToggleUserStatus = async () => {
    try {
      setStatusLoading(true);

      await api.put(`/users/${statusUser.id}/status`, {
        is_active: !statusUser.is_active
      });

      await loadAll();
      setStatusUser(null);
    } catch (err) {
      alert(
        err.response?.data?.error || "Failed to update user status"
      );
    } finally {
      setStatusLoading(false);
    }
  };

    const resetPasswordByAdmin = (row) => {
    setResetUser(row);
    setShowPasswordModal(false);
    setResetPassword("");
    setConfirmResetPassword("");
    setResetMessage("");
  };

  const submitPasswordReset = async () => {
    if (!resetPassword.trim() || !confirmResetPassword.trim()) {
      setResetMessage("❌ Please fill all fields");
      return;
    }

    const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  if (!passwordRegex.test(resetPassword)) {
    setResetMessage(
      "❌ Password must contain 8 characters, uppercase, lowercase, number and special character"
    );
    return;
  }

    if (resetPassword !== confirmResetPassword) {
      setResetMessage("❌ Passwords do not match");
      return;
    }

    try {
      setResetLoading(true);

      await api.post("/admin/reset-user-password", {
        user_id: resetUser.id,
        password: resetPassword.trim()
      });

      setResetMessage("✅ Password reset successfully");

      setTimeout(() => {
        setResetUser(null);
      }, 1200);
    } catch (err) {
      setResetMessage(
        err.response?.data?.error || "❌ Password reset failed"
      );
    } finally {
      setResetLoading(false);
    }
  };

    const addPractice = async () => {
      setMasterMessage("");
      if (!String(practice || "").trim()) {
        setMasterMessage("❌ Practice name is required");
        return;
      }

      try {
        await api.post("/practices", { name: practice });
        setMasterMessage("✅ Practice saved");
        setPractice("");
        await loadMasters();
      } catch (err) {
        setMasterMessage(
          err.response?.data?.error || "❌ Failed to save practice"
        );
      }
    };

    const togglePracticeStatus = async (row) => {
      try {
        await api.put(`/practices/${row.id}/status`, {
          is_active: !(row.is_active !== false)
        });

        setMasterMessage(
          row.is_active !== false
            ? "✅ Practice inactivated"
            : "✅ Practice activated"
        );
        await loadMasters();
      } catch (err) {
        setMasterMessage(
          err.response?.data?.error || "❌ Failed to update practice status"
        );
      }
    };

    const addDepartment = async () => {
      setMasterMessage("");
      if (!String(department || "").trim()) {
        setMasterMessage("❌ Department name is required");
        return;
      }

      try {
        await api.post("/departments", { name: department });
        setMasterMessage("✅ Department saved");
        setDepartment("");
        await loadMasters();
      } catch (err) {
        setMasterMessage(
          err.response?.data?.error || "❌ Failed to save department"
        );
      }
    };

    const addTask = async () => {
      setMasterMessage("");

      if (!String(taskPractice || "").trim()) {
        setMasterMessage("❌ Practice is required");
        return;
      }

      if (!String(taskDepartment || "").trim()) {
        setMasterMessage("❌ Department is required");
        return;
      }

      if (!String(task || "").trim()) {
        setMasterMessage("❌ Task name is required");
        return;
      }

      try {
        await api.post("/tasks", {
          name: task.trim(),
          practice: taskPractice,
          department: taskDepartment
        });
        setMasterMessage("✅ Task saved");
        setTask("");
        setTaskPractice("");
        setTaskDepartment("");
        await loadMasters();
      } catch (err) {
        setMasterMessage(err.response?.data?.error || "❌ Failed to save task");
      }
    };

    const addTarget = async () => {
      setMasterMessage("");

      if (!String(targetPractice || "").trim()) {
        setMasterMessage("❌ Practice is required");
        return;
      }

      if (!String(targetDepartment || "").trim()) {
        setMasterMessage("❌ Department is required");
        return;
      }

      if (!String(targetTask || "").trim()) {
        setMasterMessage("❌ Task is required");
        return;
      }

      if (!String(target || "").trim()) {
        setMasterMessage("❌ Target count is required");
        return;
      }

      const alreadyExists = targetsList.some(
        (item) =>
          String(item.practice || "").toLowerCase() ===
            String(targetPractice).toLowerCase() &&
          String(item.department || "").toLowerCase() ===
            String(targetDepartment).toLowerCase() &&
          String(item.task || "").toLowerCase() ===
            String(targetTask).toLowerCase()
      );

      try {
        await api.post("/targets", {
          practice: targetPractice,
          department: targetDepartment,
          task: targetTask,
          target: Number(target)
        });

        setMasterMessage(alreadyExists ? "✅ Target updated" : "✅ Target saved");
        setTargetPractice("");
        setTargetDepartment("");
        setTargetTask("");
        setTarget("");
        await loadMasters();
      } catch (err) {
        setMasterMessage(err.response?.data?.error || "❌ Failed to save target");
      }
    };

    return (
      <div style={page}>
        <div style={hero}>
          <div>
            <h2 style={title}>Admin Portal</h2>
            <p style={subtitle}>
              Manage users, organize masters, and keep admin operations clean.
            </p>
          </div>

          <button
            onClick={async () => {
              await loadAll();
              await loadMasters();
            }}
            style={refreshBtn}
          >
            <HiOutlineArrowPath style={{ fontSize: 16 }} />
            Refresh
          </button>
        </div>

        {loading ? (
          <div style={loadingCard}>Loading admin portal...</div>
        ) : (
          <>
            {activeTab === "dashboard" && (
              <div style={dashboardStack}>
                <div style={topStatsGrid}>
                  <MetricCard
                    variant="teal"
                    icon={<HiOutlineCheckCircle />}
                    value={stats.active_users}
                    label="Active Users"
                  />
                  <MetricCard
                    icon={<HiOutlineXCircle />}
                    value={inactiveCount}
                    label="Inactive Users"
                  />
                  <MetricCard
                    icon={<HiOutlineUsers />}
                    value={employeeCount}
                    label="Total Employees"
                  />
                  <MetricCard
                    icon={<HiOutlineUserGroup />}
                    value={stats.total_managers}
                    label="Total Managers"
                  />
                  <MetricCard
                    icon={<HiOutlineShieldCheck />}
                    value={stats.total_admins}
                    label="Total Admins"
                  />
                  <MetricCard
                    icon={<HiOutlineFlag />}
                    value={stats.pending_requests}
                    label="Pending Requests"
                  />
                </div>
              </div>
            )}

            {activeTab === "users" && (
              <div style={usersLayout}>
                <div style={panel}>
                  <div style={panelHeader}>
                    <h3 style={panelTitle}>
                      {editingUserId ? "Edit User" : "Create User"}
                    </h3>
                  </div>

                  <div style={formGridSingle}>

                      <div style={inputWrapper}>
    <input
      type="text"
      autoComplete="new-username"
      required
      value={userForm.username}
      onChange={(e) =>
        setUserForm((prev) => ({
          ...prev,
          username: e.target.value
        }))
      }
      style={modernInput}
    />

    <span
      style={{
        ...inputTag,
        right: userForm.username ? "16px" : "auto",
        left: userForm.username ? "auto" : "16px",
        color: userForm.username ? "#94A3B8" : "#64748B"
      }}
    >
      Username
    </span>
  </div>

  <div style={inputWrapper}>
    <input
      autoComplete="new-name"
      required
      value={userForm.name}
      onChange={(e) =>
        setUserForm((prev) => ({
          ...prev,
          name: e.target.value
        }))
      }
      style={modernInput}
    />

    <span
      style={{
        ...inputTag,
        right: userForm.name ? "16px" : "auto",
        left: userForm.name ? "auto" : "16px",
        color: userForm.name ? "#94A3B8" : "#64748B"
      }}
    >
      Full Name
    </span>
  </div>

                    {!editingUserId && (
    <div style={inputWrapper}>
      <input
        type="password"
        autoComplete="new-password"
        required
        value={userForm.password}
        onChange={(e) =>
          setUserForm((prev) => ({
            ...prev,
            password: e.target.value
          }))
        }
        style={modernInput}
      />

      <span
        style={{
          ...inputTag,
          right: userForm.password ? "16px" : "auto",
          left: userForm.password ? "auto" : "16px",
          color: userForm.password ? "#94A3B8" : "#64748B"
        }}
      >
        Password
      </span>
    </div>
  )}
                    <div style={inputWrapper}>
    <input
    required
      value={userForm.emp_id}
      onChange={(e) =>
        setUserForm((prev) => ({
          ...prev,
          emp_id: e.target.value
        }))
      }
      style={modernInput}
    />

    <span
      style={{
        ...inputTag,
        right: userForm.emp_id ? "16px" : "auto",
  left: userForm.emp_id ? "auto" : "16px",
  color: userForm.emp_id ? "#94A3B8" : "#64748B"
      }}
    >
      Employee ID 
    </span>
  </div>

                    <div style={inputWrapper}>
    <input
    autoComplete="new-email"
    required
      value={userForm.email}
      onChange={(e) =>
        setUserForm((prev) => ({
          ...prev,
          email: e.target.value
        }))
      }
      style={modernInput}
    />

    <span
      style={{
        ...inputTag,
  right: userForm.email ? "16px" : "auto",
  left: userForm.email ? "auto" : "16px",
  color: userForm.email ? "#94A3B8" : "#64748B"    }}
    >
      Email 
    </span>
  </div>

                    <select required
                      value={userForm.department}
                      onChange={(e) =>
                        setUserForm((prev) => ({ ...prev, department: e.target.value }))
                      }
                      style={input}
                    >
                      <option value="">Select Department *</option>
                      {departmentsList.map((dept) => (
                        <option key={dept.id} value={dept.name}>
                          {dept.name}
                        </option>
                      ))}
                    </select>

                    <div style={inputWrapper}>
    <input
    required
      value={userForm.designation}
      onChange={(e) =>
        setUserForm((prev) => ({
          ...prev,
          designation: e.target.value
        }))
      }
      style={modernInput}
    />

    <span
      style={{
        ...inputTag,
        right: userForm.designation ? "16px" : "auto",
  left: userForm.designation ? "auto" : "16px",
  color: userForm.designation ? "#94A3B8" : "#64748B"
      }}
    >
      Designation 
    </span>
  </div>

                    <select required
                      value={userForm.role}
                      onChange={(e) =>
                        setUserForm((prev) => ({
                          ...prev,
                          role: e.target.value,
                          manager_id: e.target.value === "user" ? prev.manager_id : ""
                        }))
                      }
                      style={input}
                    >
                      <option value="user">Employee</option>
                      <option value="manager">Manager</option>
                      <option value="admin">Admin</option>
                    </select>

                    <select
                      value={userForm.manager_id}
                      onChange={(e) =>
                        setUserForm((prev) => ({ ...prev, manager_id: e.target.value }))
                      }
                      style={input}
                      disabled={userForm.role !== "user"}
                    >
                      <option value="">
                        Select Manager {userForm.role === "user" ? "*" : ""}
                      </option>
                      {managers.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.name} ({m.role})
                        </option>
                      ))}
                    </select>
                  </div>

                  <div style={buttonRow}>
                    <button onClick={saveUser} style={primaryBtn}>
                      <HiOutlineUserPlus style={{ fontSize: 16 }} />
                      {editingUserId ? "Update User" : "Create User"}
                    </button>

                    <button
                      onClick={() => {
                        resetUserForm();
                        setUserMessage("");
                      }}
                      style={secondaryBtn}
                    >
                      Reset
                    </button>
                  </div>

                  {userMessage && (
                    <div
                      style={{
                        ...messageBox,
                        background: userMessage.includes("✅") ? "#ECFDF5" : "#FEF2F2",
                        color: userMessage.includes("✅") ? theme.success : theme.danger,
                        borderColor: userMessage.includes("✅") ? "#BBF7D0" : "#FECACA"
                      }}
                    >
                      {userMessage}
                    </div>
                  )}
                </div>

                <div style={panel}>
                  <div style={panelHeaderRow}>
                    <h3 style={panelTitle}>Users List</h3>

                    <input
                      value={userSearch}
                      onChange={(e) => setUserSearch(e.target.value)}
                      placeholder="Search users..."
                      style={searchInput}
                    />
                  </div>

                  <div style={tableWrap}>
                    <table style={table}>
                      <thead>
                        <tr style={tableHeadRow}>
    <th style={th}>Name</th>
    <th style={th}>Username</th>
    <th style={th}>Role</th>
    <th style={th}>Department</th>
                          <th style={th}>Status</th>
                          <th style={th}>Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {filteredUsers.length === 0 ? (
                          <tr>
                            <td colSpan="6" style={{ ...td, textAlign: "center" }}>
                              No users found
                            </td>
                          </tr>
                        ) : (
                          filteredUsers.map((row, index) => (
                            <tr
                              key={row.id}
                              style={{
                                background: index % 2 === 0 ? "#FFFFFF" : "#F8FAFC"
                              }}
                            >
                              <td style={td}>
                                <div style={userName}>{row.name}</div>
                                <div style={subText}>{row.email || "-"}</div>
  <div style={subText}>EMP ID: {row.emp_id || "-"}</div>
                              </td>
  <td style={td}>{row.username || "-"}</td>
                              <td style={td}>
                                <span
                                  style={{
                                    ...roleBadge,
                                    ...(String(row.role || "").toLowerCase() === "admin"
                                      ? adminBadge
                                      : String(row.role || "").toLowerCase() === "manager"
                                      ? managerBadge
                                      : employeeBadge)
                                  }}
                                >
                                  {row.role}
                                </span>
                              </td>

                              <td style={td}>{row.department || "-"}</td>
                            

                              <td style={td}>
                                <span
                                  style={{
                                    ...statusBadge,
                                    background: row.is_active ? "#ECFDF5" : "#FEF2F2",
                                    color: row.is_active ? theme.success : theme.danger
                                  }}
                                >
                                  {row.is_active ? "Active" : "Inactive"}
                                </span>
                              </td>

                              <td style={td}>
                                <div style={actionRow}>
                                  <button
                                    type="button"
                                    onClick={() => startEditUser(row)}
                                    style={iconBtn}
                                    title="Edit"
                                  >
                                    <HiOutlinePencilSquare />
                                  </button>

                                  <button
                                    type="button"
                                    onClick={() => resetPasswordByAdmin(row)}
                                    style={iconBtn}
                                    title="Reset password"
                                  >
                                    <HiOutlineKey />
                                  </button>

  <button
    type="button"
    onClick={() => toggleUserStatus(row)}
    style={iconBtn}
    title={row.is_active ? "Deactivate User" : "Activate User"}
  >
    {row.is_active ? <HiOutlineXCircle /> : <HiOutlineCheckCircle />}
  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "controls" && (
              <div style={controlsPageStack}>
                <div style={controlsHeaderCard}>
                  <h3 style={controlsHeaderTitle}>Control Center</h3>
                  <p style={controlsHeaderSub}>
                    Manage organization structure, workflows, and targets in one place.
                  </p>
                </div>

                <div style={controlsNavGrid}>
                  <NavSectionCard
                    icon={<HiOutlineBuildingOffice2 />}
                    title="Organization"
                    text="Manage practices and departments for your organization."
                    buttonLabel="Open Organization"
                    onClick={() => setActiveTab("controls_org")}
                  />

                  <NavSectionCard
                    icon={<HiOutlineClipboardDocumentList />}
                    title="Tasks"
                    text="Create and manage tasks by practice and department."
                    buttonLabel="Open Tasks"
                    onClick={() => setActiveTab("controls_tasks")}
                  />

                  <NavSectionCard
                    icon={<HiOutlineCalendarDays />}
                    title="Targets"
                    text="Set and update productivity targets for tasks."
                    buttonLabel="Open Targets"
                    onClick={() => setActiveTab("controls_targets")}
                  />
                </div>
              </div>
            )}

            {activeTab === "controls_org" && (
              <div style={controlsPageStack}>
                <SectionTopBar
                  title="Organization"
                  subtitle="Add masters in small entry boxes and review them in tables."
                  onBack={() => setActiveTab("controls")}
                />

                <div style={controlsGrid}>
                  <PracticeMasterCard
                    icon={<HiOutlineClipboardDocumentList />}
                    title="Practices"
                    inputValue={practice}
                    setInputValue={setPractice}
                    inputPlaceholder="Enter practice name"
                    buttonLabel="Add Practice"
                    onSubmit={addPractice}
                    rows={filteredPractices}
                    searchValue={practiceSearch}
                    setSearchValue={setPracticeSearch}
                    searchPlaceholder="Search practices..."
                    onToggleStatus={togglePracticeStatus}
                  />

                  <SimpleMasterCard
                    icon={<HiOutlineBuildingOffice2 />}
                    title="Departments"
                    inputValue={department}
                    setInputValue={setDepartment}
                    inputPlaceholder="Enter department name"
                    buttonLabel="Add Department"
                    onSubmit={addDepartment}
                    rows={filteredDepartments}
                    searchValue={departmentSearch}
                    setSearchValue={setDepartmentSearch}
                    searchPlaceholder="Search departments..."
                    columns={["Department Name"]}
                    renderRow={(row) => [row.name]}
                  />
                </div>

                {masterMessage && (
                  <div
                    style={{
                      ...messageBox,
                      background: masterMessage.includes("✅") ? "#ECFDF5" : "#FEF2F2",
                      color: masterMessage.includes("✅") ? theme.success : theme.danger,
                      borderColor: masterMessage.includes("✅") ? "#BBF7D0" : "#FECACA"
                    }}
                  >
                    {masterMessage}
                  </div>
                )}
              </div>
            )}

            {activeTab === "controls_tasks" && (
              <div style={controlsPageStack}>
                <SectionTopBar
                  title="Tasks"
                  subtitle="Select practice and department, enter a task, and save it below."
                  onBack={() => setActiveTab("controls")}
                />

                <div style={controlsGridSingle}>
                  <div style={controlCard}>
                    <div style={controlCardHeader}>
                      <div style={controlCardIcon}>
                        <HiOutlineClipboardDocumentList />
                      </div>
                      <div>
                        <h3 style={controlCardTitle}>Create Task</h3>
                        <p style={controlCardSub}>
                          Choose practice and department, then enter the task name.
                        </p>
                      </div>
                    </div>

                    <div style={formGridSingle}>
                      <select
                        value={taskPractice}
                        onChange={(e) => setTaskPractice(e.target.value)}
                        style={input}
                      >
                        <option value="">Select Practice</option>
                        {activePracticesOnly.map((p) => (
                          <option key={p.id} value={p.name}>
                            {p.name}
                          </option>
                        ))}
                      </select>

                      <select
                        value={taskDepartment}
                        onChange={(e) => setTaskDepartment(e.target.value)}
                        style={input}
                      >
                        <option value="">Select Department</option>
                        {departmentsList.map((d) => (
                          <option key={d.id} value={d.name}>
                            {d.name}
                          </option>
                        ))}
                      </select>

                      <input
                        value={task}
                        onChange={(e) => setTask(e.target.value)}
                        placeholder="Enter task name"
                        style={input}
                      />
                    </div>

                    <div style={buttonRow}>
                      <button onClick={addTask} style={primaryBtn}>
                        Create Task
                      </button>
                    </div>
                  </div>

                  <div style={controlCard}>
                    <div style={panelHeaderRow}>
                      <h3 style={panelTitle}>Tasks List</h3>
                      <input
                        value={taskListSearch}
                        onChange={(e) => setTaskListSearch(e.target.value)}
                        placeholder="Search by practice, department or task..."
                        style={searchInputWide}
                      />
                    </div>

                    <div style={tableWrap}>
                      <table style={table}>
                        <thead>
                          <tr style={tableHeadRow}>
                            <th style={th}>Task</th>
                            <th style={th}>Practice</th>
                            <th style={th}>Department</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredTasks.length === 0 ? (
                            <tr>
                              <td colSpan="3" style={{ ...td, textAlign: "center" }}>
                                No tasks found
                              </td>
                            </tr>
                          ) : (
                            filteredTasks.map((row) => (
                              <tr key={row.id}>
                                <td style={td}>{row.name || row.task || "-"}</td>
                                <td style={td}>{row.practice || "-"}</td>
                                <td style={td}>{row.department || "-"}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {masterMessage && (
                  <div
                    style={{
                      ...messageBox,
                      background: masterMessage.includes("✅") ? "#ECFDF5" : "#FEF2F2",
                      color: masterMessage.includes("✅") ? theme.success : theme.danger,
                      borderColor: masterMessage.includes("✅") ? "#BBF7D0" : "#FECACA"
                    }}
                  >
                    {masterMessage}
                  </div>
                )}
              </div>
            )}

            {activeTab === "controls_targets" && (
              <div style={controlsPageStack}>
                <SectionTopBar
                  title="Targets"
                  subtitle="Set targets on the left and review current default targets on the right."
                  onBack={() => setActiveTab("controls")}
                />

                <div style={controlsGrid}>
                  <div style={controlCard}>
                    <div style={controlCardHeader}>
                      <div style={controlCardIcon}>
                        <HiOutlineFlag />
                      </div>
                      <div>
                        <h3 style={controlCardTitle}>Set Target</h3>
                        <p style={controlCardSub}>
                          Choose practice, department, task, then set the target count.
                        </p>
                      </div>
                    </div>

                    <div style={formGridSingle}>
                      <select
                        value={targetPractice}
                        onChange={(e) => {
                          setTargetPractice(e.target.value);
                          setTargetTask("");
                        }}
                        style={input}
                      >
                        <option value="">Select Practice</option>
                        {activePracticesOnly.map((p) => (
                          <option key={p.id} value={p.name}>
                            {p.name}
                          </option>
                        ))}
                      </select>

                      <select
                        value={targetDepartment}
                        onChange={(e) => {
                          setTargetDepartment(e.target.value);
                          setTargetTask("");
                        }}
                        style={input}
                      >
                        <option value="">Select Department</option>
                        {departmentsList.map((d) => (
                          <option key={d.id} value={d.name}>
                            {d.name}
                          </option>
                        ))}
                      </select>

                      <select
                        value={targetTask}
                        onChange={(e) => setTargetTask(e.target.value)}
                        style={input}
                        disabled={!targetPractice || !targetDepartment}
                      >
                        <option value="">
                          {!targetPractice || !targetDepartment
                            ? "Select Practice and Department first"
                            : "Select Task"}
                        </option>
                        {availableTasksForTarget.map((t) => (
                          <option key={t.id} value={t.name || t.task}>
                            {t.name || t.task}
                          </option>
                        ))}
                      </select>

                      <input
                        type="number"
                        value={target}
                        onChange={(e) => setTarget(e.target.value)}
                        placeholder="Enter target count"
                        style={input}
                      />
                    </div>

                    <div style={buttonRow}>
                      <button onClick={addTarget} style={primaryBtn}>
                        Submit Target
                      </button>
                    </div>
                  </div>

                  <div style={controlCard}>
                    <div style={controlCardHeader}>
                      <div style={controlCardIcon}>
                        <HiOutlineClipboardDocumentList />
                      </div>
                      <div>
                        <h3 style={controlCardTitle}>Default Targets</h3>
                        <p style={controlCardSub}>
                          Current target setup. Updating the same combination replaces
                          the old value.
                        </p>
                      </div>
                    </div>

                    <div style={tableWrap}>
                      <table style={table}>
                        <thead>
                          <tr style={tableHeadRow}>
                            <th style={th}>Practice</th>
                            <th style={th}>Department</th>
                            <th style={th}>Task</th>
                            <th style={th}>Target</th>
                          </tr>
                        </thead>
                        <tbody>
                          {defaultTargets.length === 0 ? (
                            <tr>
                              <td colSpan="4" style={{ ...td, textAlign: "center" }}>
                                No default targets found
                              </td>
                            </tr>
                          ) : (
                            defaultTargets.map((row) => (
                              <tr key={row.id}>
                                <td style={td}>{row.practice || "-"}</td>
                                <td style={td}>{row.department || "-"}</td>
                                <td style={td}>{row.task || "-"}</td>
                                <td style={td}>{row.target || "-"}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div style={controlCard}>
                  <div style={panelHeaderRow}>
                    <h3 style={panelTitle}>Targets List</h3>
                    <input
                      value={targetListSearch}
                      onChange={(e) => setTargetListSearch(e.target.value)}
                      placeholder="Search by practice, department or task..."
                      style={searchInputWide}
                    />
                  </div>

                  <div style={tableWrap}>
                    <table style={table}>
                      <thead>
                        <tr style={tableHeadRow}>
                          <th style={th}>Practice</th>
                          <th style={th}>Department</th>
                          <th style={th}>Task</th>
                          <th style={th}>Target</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredTargets.length === 0 ? (
                          <tr>
                            <td colSpan="4" style={{ ...td, textAlign: "center" }}>
                              No targets found
                            </td>
                          </tr>
                        ) : (
                          filteredTargets.map((row) => (
                            <tr key={row.id}>
                              <td style={td}>{row.practice || "-"}</td>
                              <td style={td}>{row.department || "-"}</td>
                              <td style={td}>{row.task || "-"}</td>
                              <td style={td}>{row.target || "-"}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {masterMessage && (
                  <div
                    style={{
                      ...messageBox,
                      background: masterMessage.includes("✅") ? "#ECFDF5" : "#FEF2F2",
                      color: masterMessage.includes("✅") ? theme.success : theme.danger,
                      borderColor: masterMessage.includes("✅") ? "#BBF7D0" : "#FECACA"
                    }}
                  >
                    {masterMessage}
                  </div>
                )}
              </div>
            )}

            {activeTab === "hierarchy" && (
              <div style={controlsPageStack}>
                <SectionTopBar
                  title="Organization Hierarchy"
                  subtitle="View reporting relationships across leadership, managers, and employees."
                  onBack={() => setActiveTab("controls")}
                />

                <div style={orgChartCard}>
                  <div style={orgChartCanvas}>
                    {leadershipUsers.length > 0 && (
                      <>
                        <div style={orgTopRow}>
                          {leadershipUsers.map((leader) => (
                            <div key={leader.id} style={orgTopNode}>
                              <div style={orgNodeName}>{leader.name}</div>
                              <div style={orgNodeMeta}>
                                {leader.designation || leader.role || "Admin"}
                              </div>
                            </div>
                          ))}
                        </div>

                        <div style={orgTopConnector} />
                      </>
                    )}

                    <div style={orgManagersRow}>
                      {managerUsers.length === 0 ? (
                        <div style={emptyHierarchyCard}>No managers found.</div>
                      ) : (
                        managerUsers.map((manager) => {
                          const team = employeesByManager[String(manager.id)] || [];

                          return (
                            <div key={manager.id} style={orgManagerColumn}>
                              <div style={orgManagerNode}>
                                <div style={orgNodeName}>{manager.name}</div>
                                <div style={orgNodeMeta}>
                                  {manager.designation || "Manager"}
                                </div>
                              </div>

                              <div style={orgManagerConnector} />

                              <div style={orgEmployeesColumn}>
                                {team.length === 0 ? (
                                  <div style={orgEmptyNode}>No team assigned</div>
                                ) : (
                                  team.map((emp) => (
                                    <div key={emp.id} style={orgEmployeeNode}>
                                      <div style={orgEmployeeName}>{emp.name}</div>
                                      <div style={orgEmployeeMeta}>
                                        {emp.designation || "Employee"}
                                        {emp.department ? ` • ${emp.department}` : ""}
                                      </div>
                                    </div>
                                  ))
                                )}
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>

                {unassignedEmployees.length > 0 && (
                  <div style={hierarchySection}>
                    <div style={hierarchySectionHeader}>
                      <h3 style={hierarchySectionTitle}>Unassigned Employees</h3>
                      <p style={hierarchySectionSub}>
                        Employees without a manager mapping.
                      </p>
                    </div>

                    <div style={unassignedGrid}>
                      {unassignedEmployees.map((emp) => (
                        <div key={emp.id} style={unassignedCard}>
                          <div style={unassignedName}>{emp.name}</div>
                          <div style={unassignedMeta}>
                            {emp.designation || "Employee"}
                            {emp.department ? ` • ${emp.department}` : ""}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        )}

  {statusUser && (
    <div style={resetOverlay}>
      <div style={resetModal}>
        <h3 style={resetTitle}>
          {statusUser.is_active ? "Deactivate User" : "Activate User"}
        </h3>

        <p style={resetText}>
          Do you want to{" "}
          <strong>
            {statusUser.is_active ? "deactivate" : "activate"}
          </strong>{" "}
          the user <strong>{statusUser.name}</strong>?
        </p>

        <div style={resetButtonRow}>
          <button
            onClick={() => setStatusUser(null)}
            style={resetCancelBtn}
          >
            Cancel
          </button>

          <button
            onClick={confirmToggleUserStatus}
            style={{
              ...resetConfirmBtn,
              background: statusUser.is_active
                ? "linear-gradient(135deg, #DC2626, #EF4444)"
                : "linear-gradient(135deg, #0F766E, #14B8A6)"
            }}
          >
            {statusLoading
              ? "Please wait..."
              : statusUser.is_active
              ? "Yes, Deactivate"
              : "Yes, Activate"}
          </button>
        </div>
      </div>
    </div>
  )}

  {resetUser && (
    <div style={resetOverlay}>
      <div style={resetModal}>
        <h3 style={resetTitle}>Reset Password</h3>

        {!showPasswordModal ? (
          <>
            <p style={resetText}>
              Do you really want to reset password for{" "}
              <strong>{resetUser.name}</strong>?
            </p>

            <div style={resetButtonRow}>
              <button
                onClick={() => {
                  setResetUser(null);
                  setShowPasswordModal(false);
                }}
                style={resetCancelBtn}
              >
                Cancel
              </button>

              <button
                onClick={() => setShowPasswordModal(true)}
                style={resetConfirmBtn}
              >
                Yes, Proceed
              </button>
            </div>
          </>
        ) : (
          <>
            <p style={resetText}>
              Changing password for <strong>{resetUser.name}</strong>
            </p>

  <div style={passwordWrapper}>
    <input
      type={showResetPassword ? "text" : "password"}
      placeholder="Enter new password"
      value={resetPassword}
      onChange={(e) => {
        setResetPassword(e.target.value);
        setResetMessage("");
      }}
      style={resetInput}
    />

    <button
    type="button"
    tabIndex={-1}
      onClick={() =>
        setShowResetPassword(!showResetPassword)
      }
      style={eyeBtn}
    >
      {showResetPassword ? (
    <HiOutlineEyeSlash />
  ) : (
    <HiOutlineEye />
  )}
    </button>
  </div>

            <div style={passwordWrapper}>
    <input
      type={showConfirmResetPassword ? "text" : "password"}
      placeholder="Confirm new password"
      value={confirmResetPassword}
      onChange={(e) => {
        setConfirmResetPassword(e.target.value);
        setResetMessage("");
      }}
      style={resetInput}
    />

    <button
    type="button"
    tabIndex={-1}
      onClick={() =>
        setShowConfirmResetPassword(
          !showConfirmResetPassword
        )
      }
      style={eyeBtn}
    >
      {showResetPassword ? (
    <HiOutlineEyeSlash />
  ) : (
    <HiOutlineEye />
  )}
    </button>
  </div>

            {resetMessage && (
              <div style={resetMessageBox}>
                {resetMessage}
              </div>
            )}

            <div style={resetButtonRow}>
              <button
                onClick={() => setShowPasswordModal(false)}
                style={resetCancelBtn}
              >
                Back
              </button>

              <button
                onClick={submitPasswordReset}
                style={resetConfirmBtn}
                disabled={resetLoading}
              >
                {resetLoading ? "Updating..." : "Reset Password"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )}
      
      </div>
    );
  }

  function MetricCard({ icon, value, label, variant = "default" }) {
    const isTeal = variant === "teal";

    return (
      <div style={{ ...metricCard, ...(isTeal ? metricCardTeal : {}) }}>
        <div style={{ ...metricIcon, ...(isTeal ? metricIconTeal : {}) }}>{icon}</div>
        <div>
          <h3 style={{ ...metricValue, ...(isTeal ? metricValueTeal : {}) }}>
            {value}
          </h3>
          <p style={{ ...metricLabel, ...(isTeal ? metricLabelTeal : {}) }}>
            {label}
          </p>
        </div>
      </div>
    );
  }

  function NavSectionCard({ icon, title, text, buttonLabel, onClick }) {
    return (
      <div style={navCard}>
        <div style={navCardIcon}>{icon}</div>
        <div style={navCardBody}>
          <h3 style={navCardTitle}>{title}</h3>
          <p style={navCardText}>{text}</p>
        </div>
        <button type="button" onClick={onClick} style={navCardBtn}>
          {buttonLabel}
        </button>
      </div>
    );
  }

  function SectionTopBar({ title, subtitle, onBack }) {
    return (
      <div style={sectionTopBar}>
        <div>
          <h3 style={sectionTopTitle}>{title}</h3>
          <p style={sectionTopSub}>{subtitle}</p>
        </div>

        <button type="button" onClick={onBack} style={backBtn}>
          <HiOutlineArrowLeft style={{ fontSize: 16 }} />
          Back
        </button>
      </div>
    );
  }

  function PracticeMasterCard({
    icon,
    title,
    inputValue,
    setInputValue,
    inputPlaceholder,
    buttonLabel,
    onSubmit,
    rows,
    searchValue,
    setSearchValue,
    searchPlaceholder,
    onToggleStatus
  }) {
    return (
      <div style={controlCard}>
        <div style={controlCardHeader}>
          <div style={controlCardIcon}>{icon}</div>
          <div>
            <h3 style={controlCardTitle}>{title}</h3>
            <p style={controlCardSub}>
              Add new practices, and activate or inactivate them here.
            </p>
          </div>
        </div>

        <div style={smallEntryBox}>
          <input
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder={inputPlaceholder}
            style={input}
          />
          <button onClick={onSubmit} style={primaryBtn}>
            {buttonLabel}
          </button>
        </div>

        <div style={{ marginTop: 20 }}>
          <div style={panelHeaderRow}>
            <h3 style={tableTitle}>{title} List</h3>
            <input
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder={searchPlaceholder}
              style={searchInputSmall}
            />
          </div>

          <div style={tableWrap}>
            <table style={table}>
              <thead>
                <tr style={tableHeadRow}>
                  <th style={th}>Practice Name</th>
                  <th style={th}>Status</th>
                  <th style={th}>Action</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan="3" style={{ ...td, textAlign: "center" }}>
                      No records found
                    </td>
                  </tr>
                ) : (
                  rows.map((row) => (
                    <tr key={row.id}>
                      <td style={td}>{row.name || "-"}</td>
                      <td style={td}>
                        <span
                          style={{
                            ...statusBadge,
                            background:
                              row.is_active !== false ? "#ECFDF5" : "#FEF2F2",
                            color:
                              row.is_active !== false ? theme.success : theme.danger
                          }}
                        >
                          {row.is_active !== false ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td style={td}>
                        <button
                          type="button"
                          onClick={() => onToggleStatus(row)}
                          style={{
                            ...practiceToggleBtn,
                            background:
                              row.is_active !== false ? "#FEF2F2" : "#ECFDF5",
                            color:
                              row.is_active !== false ? theme.danger : theme.success
                          }}
                        >
                          {row.is_active !== false ? "Inactivate" : "Activate"}
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  function SimpleMasterCard({
    icon,
    title,
    inputValue,
    setInputValue,
    inputPlaceholder,
    buttonLabel,
    onSubmit,
    rows,
    searchValue,
    setSearchValue,
    searchPlaceholder,
    columns,
    renderRow
  }) {
    return (
      <div style={controlCard}>
        <div style={controlCardHeader}>
          <div style={controlCardIcon}>{icon}</div>
          <div>
            <h3 style={controlCardTitle}>{title}</h3>
            <p style={controlCardSub}>
              Add new {title.toLowerCase()} and review the list below.
            </p>
          </div>
        </div>

        <div style={smallEntryBox}>
          <input
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder={inputPlaceholder}
            style={input}
          />
          <button onClick={onSubmit} style={primaryBtn}>
            {buttonLabel}
          </button>
        </div>

        <div style={{ marginTop: 20 }}>
          <div style={panelHeaderRow}>
            <h3 style={tableTitle}>{title} List</h3>
            <input
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder={searchPlaceholder}
              style={searchInputSmall}
            />
          </div>

          <div style={tableWrap}>
            <table style={table}>
              <thead>
                <tr style={tableHeadRow}>
                  {columns.map((col) => (
                    <th key={col} style={th}>
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={columns.length} style={{ ...td, textAlign: "center" }}>
                      No records found
                    </td>
                  </tr>
                ) : (
                  rows.map((row) => {
                    const values = renderRow(row);
                    return (
                      <tr key={row.id}>
                        {values.map((value, idx) => (
                          <td key={`${row.id}-${idx}`} style={td}>
                            {value || "-"}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  /* ================= STYLES ================= */

  const page = {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    color: theme.text
  };

  const hero = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap"
  };

  const title = {
    margin: 0,
    fontSize: "30px",
    fontWeight: 800,
    color: theme.text
  };

  const subtitle = {
    margin: "8px 0 0 0",
    color: theme.textMuted,
    fontSize: "14px",
    lineHeight: 1.6
  };

  const refreshBtn = {
    border: "none",
    borderRadius: "18px",
    padding: "14px 22px",
    background: "linear-gradient(135deg, #0F8A7D 0%, #12B4A6 100%)",
    color: "#fff",
    fontSize: "14px",
    fontWeight: 700,
    display: "inline-flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
    boxShadow: "0 14px 28px rgba(15,118,110,0.18)"
  };

  const tabRow = {
    display: "flex",
    gap: "12px",
    flexWrap: "wrap"
  };

  const tabBtn = {
    border: `1px solid ${theme.borderSoft}`,
    background: theme.surface,
    color: theme.textMuted,
    borderRadius: "16px",
    padding: "12px 20px",
    fontSize: "14px",
    fontWeight: 700,
    cursor: "pointer"
  };

  const activeTabBtn = {
    background: "linear-gradient(135deg, #0F8A7D 0%, #12B4A6 100%)",
    color: "#fff",
    borderColor: "transparent"
  };

  const loadingCard = {
    background: theme.surface,
    borderRadius: "20px",
    border: `1px solid ${theme.borderSoft}`,
    padding: "28px",
    color: theme.textMuted,
    fontWeight: 600
  };

  const dashboardStack = {
    display: "flex",
    flexDirection: "column"
  };

  const topStatsGrid = {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: "16px"
  };

  const metricCard = {
    background: theme.surface,
    border: `1px solid ${theme.borderSoft}`,
    borderRadius: "20px",
    padding: "16px 18px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minHeight: "94px",
    boxShadow: "0 10px 22px rgba(15,23,42,0.05)"
  };

  const metricCardTeal = {
    background: "linear-gradient(135deg, #0F8A7D 0%, #12B4A6 100%)",
    borderColor: "transparent"
  };

  const metricIcon = {
    width: "42px",
    height: "42px",
    borderRadius: "14px",
    background: theme.surfaceSoft,
    color: theme.primary,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    flexShrink: 0
  };

  const metricIconTeal = {
    background: "rgba(255,255,255,0.18)",
    color: "#fff"
  };

  const metricValue = {
    margin: 0,
    fontSize: "22px",
    fontWeight: 800,
    color: theme.text
  };

  const metricValueTeal = {
    color: "#fff"
  };

  const metricLabel = {
    margin: "4px 0 0 0",
    fontSize: "12px",
    color: theme.textMuted,
    fontWeight: 600
  };

  const metricLabelTeal = {
    color: "rgba(255,255,255,0.9)"
  };

  const panel = {
    background: theme.surface,
    borderRadius: "26px",
    border: `1px solid ${theme.borderSoft}`,
    boxShadow: "0 16px 34px rgba(15,23,42,0.06)",
    padding: "28px",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    boxSizing: "border-box"
  };

  const panelHeader = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "18px"
  };

  const panelHeaderRow = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    marginBottom: "18px",
    flexWrap: "wrap"
  };

  const panelTitle = {
    margin: 0,
    fontSize: "24px",
    fontWeight: 800,
    color: theme.text
  };

  const tableTitle = {
    margin: 0,
    fontSize: "20px",
    fontWeight: 800,
    color: theme.text
  };

  const usersLayout = {
    display: "grid",
    gridTemplateColumns: "0.8fr 1.2fr",
    gap: "22px",
    alignItems: "stretch"
  };

  const formGridSingle = {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "14px"
  };

  const input = {
    width: "100%",
    padding: "14px 16px",
    borderRadius: "18px",
    border: `1px solid ${theme.borderSoft}`,
    fontSize: "14px",
    color: theme.text,
    outline: "none",
    background: "#fff",
    boxSizing: "border-box"
  };

  const buttonRow = {
    display: "flex",
    gap: "12px",
    flexWrap: "wrap",
    marginTop: "18px"
  };

  const primaryBtn = {
    border: "none",
    borderRadius: "18px",
    padding: "14px 22px",
    background: "linear-gradient(135deg, #0F8A7D 0%, #12B4A6 100%)",
    color: "#fff",
    fontSize: "14px",
    fontWeight: 700,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    cursor: "pointer",
    boxShadow: "0 12px 24px rgba(15,118,110,0.16)"
  };

  const secondaryBtn = {
    border: `1px solid ${theme.borderSoft}`,
    borderRadius: "18px",
    padding: "14px 22px",
    background: theme.surface,
    color: theme.text,
    fontSize: "14px",
    fontWeight: 700,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    cursor: "pointer"
  };

  const messageBox = {
    marginTop: "16px",
    borderRadius: "16px",
    padding: "12px 14px",
    border: "1px solid transparent",
    fontWeight: 700,
    fontSize: "13px"
  };

  const searchInput = {
    width: "320px",
    maxWidth: "100%",
    padding: "14px 16px",
    borderRadius: "18px",
    border: `1px solid ${theme.borderSoft}`,
    fontSize: "14px",
    color: theme.text,
    outline: "none",
    background: "#fff",
    boxSizing: "border-box"
  };

  const searchInputSmall = {
    width: "240px",
    maxWidth: "100%",
    padding: "12px 14px",
    borderRadius: "16px",
    border: `1px solid ${theme.borderSoft}`,
    fontSize: "14px",
    color: theme.text,
    outline: "none",
    background: "#fff",
    boxSizing: "border-box"
  };

  const searchInputWide = {
    width: "360px",
    maxWidth: "100%",
    padding: "12px 14px",
    borderRadius: "16px",
    border: `1px solid ${theme.borderSoft}`,
    fontSize: "14px",
    color: theme.text,
    outline: "none",
    background: "#fff",
    boxSizing: "border-box"
  };

  const tableWrap = {
    overflowX: "auto",
    flex: 1
  };

  const table = {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0
  };

  const tableHeadRow = {
    background: "#F8FAFC"
  };

  const th = {
    padding: "16px 14px",
    textAlign: "left",
    fontSize: "13px",
    fontWeight: 800,
    color: theme.textMuted,
    borderBottom: `1px solid ${theme.borderSoft}`,
    whiteSpace: "nowrap"
  };

  const td = {
    padding: "16px 14px",
    fontSize: "14px",
    color: theme.text,
    borderBottom: `1px solid #EEF2F7`,
    verticalAlign: "middle"
  };

  const userName = {
    fontSize: "15px",
    fontWeight: 800,
    color: theme.text
  };

  const subText = {
    marginTop: "4px",
    fontSize: "12px",
    color: theme.textMuted
  };

  const roleBadge = {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "999px",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 800,
    textTransform: "capitalize"
  };

  const adminBadge = {
    background: "#ECFDF5",
    color: theme.success
  };

  const managerBadge = {
    background: "#ECFEFF",
    color: theme.primaryDark
  };

  const employeeBadge = {
    background: "#FFFBEB",
    color: theme.warning
  };

  const statusBadge = {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "999px",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 800
  };

  const actionRow = {
    display: "flex",
    gap: "10px",
    alignItems: "center"
  };

  const iconBtn = {
    width: "40px",
    height: "40px",
    borderRadius: "14px",
    border: `1px solid ${theme.borderSoft}`,
    background: theme.surface,
    color: theme.primaryDark,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    cursor: "pointer"
  };

  const practiceToggleBtn = {
    border: "none",
    borderRadius: "12px",
    padding: "9px 12px",
    fontSize: "12px",
    fontWeight: 800,
    cursor: "pointer"
  };

  const controlsPageStack = {
    display: "flex",
    flexDirection: "column",
    gap: "18px"
  };

  const controlsHeaderCard = {
    background: "linear-gradient(135deg, #ECFEFF 0%, #FFFFFF 100%)",
    borderRadius: "22px",
    padding: "22px",
    border: `1px solid ${theme.border}`,
    boxShadow: "0 12px 28px rgba(15,23,42,0.06)"
  };

  const controlsHeaderTitle = {
    margin: 0,
    fontSize: "22px",
    fontWeight: 800,
    color: theme.text
  };

  const controlsHeaderSub = {
    margin: "8px 0 0 0",
    color: theme.textMuted,
    fontSize: "14px",
    lineHeight: 1.6
  };

  const controlsNavGrid = {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: "18px"
  };

  const navCard = {
    background: theme.surface,
    borderRadius: "22px",
    border: `1px solid ${theme.borderSoft}`,
    boxShadow: "0 12px 28px rgba(15,23,42,0.06)",
    padding: "22px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    minHeight: "220px"
  };

  const navCardIcon = {
    width: "52px",
    height: "52px",
    borderRadius: "16px",
    background: theme.surfaceSoft,
    color: theme.primary,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px"
  };

  const navCardBody = {
    flex: 1
  };

  const navCardTitle = {
    margin: 0,
    fontSize: "18px",
    fontWeight: 800,
    color: theme.text
  };

  const navCardText = {
    margin: "8px 0 0 0",
    fontSize: "14px",
    color: theme.textMuted,
    lineHeight: 1.6
  };

  const navCardBtn = {
    border: "none",
    borderRadius: "14px",
    padding: "12px 16px",
    background: "linear-gradient(135deg, #0F766E 0%, #14B8A6 100%)",
    color: "#fff",
    fontSize: "14px",
    fontWeight: 700,
    cursor: "pointer"
  };

  const sectionTopBar = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap",
    background: theme.surface,
    borderRadius: "20px",
    padding: "18px 20px",
    border: `1px solid ${theme.borderSoft}`,
    boxShadow: "0 12px 28px rgba(15,23,42,0.05)"
  };

  const sectionTopTitle = {
    margin: 0,
    fontSize: "20px",
    fontWeight: 800,
    color: theme.text
  };

  const sectionTopSub = {
    margin: "6px 0 0 0",
    fontSize: "13px",
    color: theme.textMuted
  };

  const backBtn = {
    border: `1px solid ${theme.borderSoft}`,
    borderRadius: "14px",
    padding: "10px 16px",
    background: theme.surface,
    color: theme.text,
    fontSize: "14px",
    fontWeight: 700,
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer"
  };

  const controlsGrid = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "18px"
  };

  const controlsGridSingle = {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "18px"
  };

  const controlCard = {
    background: theme.surface,
    borderRadius: "22px",
    border: `1px solid ${theme.borderSoft}`,
    boxShadow: "0 12px 28px rgba(15,23,42,0.06)",
    padding: "22px"
  };

  const controlCardHeader = {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "18px"
  };

  const controlCardIcon = {
    width: "48px",
    height: "48px",
    borderRadius: "16px",
    background: theme.surfaceSoft,
    color: theme.primary,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "22px",
    flexShrink: 0
  };

  const controlCardTitle = {
    margin: 0,
    fontSize: "18px",
    fontWeight: 800,
    color: theme.text
  };

  const controlCardSub = {
    margin: "6px 0 0 0",
    fontSize: "13px",
    color: theme.textMuted
  };

  const smallEntryBox = {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    gap: "12px",
    alignItems: "center"
  };

  const hierarchySection = {
    background: theme.surface,
    borderRadius: "22px",
    border: `1px solid ${theme.borderSoft}`,
    boxShadow: "0 12px 28px rgba(15,23,42,0.06)",
    padding: "22px"
  };

  const hierarchySectionHeader = {
    marginBottom: "18px"
  };

  const hierarchySectionTitle = {
    margin: 0,
    fontSize: "20px",
    fontWeight: 800,
    color: theme.text
  };

  const hierarchySectionSub = {
    margin: "6px 0 0 0",
    fontSize: "13px",
    color: theme.textMuted
  };

  const orgChartCard = {
    background: theme.surface,
    borderRadius: "22px",
    border: `1px solid ${theme.borderSoft}`,
    boxShadow: "0 12px 28px rgba(15,23,42,0.06)",
    padding: "24px",
    overflowX: "auto"
  };

  const orgChartCanvas = {
    minWidth: "900px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0"
  };

  const orgTopRow = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "18px",
    marginBottom: "0"
  };

  const orgTopNode = {
    minWidth: "220px",
    maxWidth: "260px",
    background: "linear-gradient(135deg, #0B4F57 0%, #0F766E 100%)",
    color: "#fff",
    borderRadius: "18px",
    padding: "14px 18px",
    textAlign: "center",
    boxShadow: "0 12px 26px rgba(15,118,110,0.18)"
  };

  const orgTopConnector = {
    width: "2px",
    height: "36px",
    background: "#CBD5E1",
    margin: "0 auto 6px auto"
  };

  const orgManagersRow = {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "22px",
    alignItems: "start"
  };

  const orgManagerColumn = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative"
  };

  const orgManagerNode = {
    minWidth: "200px",
    maxWidth: "240px",
    background: "linear-gradient(135deg, #0F766E 0%, #14B8A6 100%)",
    color: "#fff",
    borderRadius: "16px",
    padding: "12px 16px",
    textAlign: "center",
    boxShadow: "0 10px 22px rgba(20,184,166,0.18)"
  };

  const orgManagerConnector = {
    width: "2px",
    height: "26px",
    background: "#CBD5E1",
    margin: "8px 0 10px 0"
  };

  const orgEmployeesColumn = {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    alignItems: "center",
    width: "100%"
  };

  const orgEmployeeNode = {
    minWidth: "180px",
    maxWidth: "220px",
    background: "#EFFCFB",
    border: `1px solid ${theme.border}`,
    borderRadius: "14px",
    padding: "10px 14px",
    textAlign: "center",
    boxShadow: "0 8px 18px rgba(15,23,42,0.05)"
  };

  const orgNodeName = {
    fontSize: "14px",
    fontWeight: 800,
    lineHeight: 1.3
  };

  const orgNodeMeta = {
    marginTop: "4px",
    fontSize: "11px",
    opacity: 0.92
  };

  const orgEmployeeName = {
    fontSize: "13px",
    fontWeight: 700,
    color: theme.text
  };

  const orgEmployeeMeta = {
    marginTop: "4px",
    fontSize: "11px",
    color: theme.textMuted
  };

  const orgEmptyNode = {
    minWidth: "180px",
    maxWidth: "220px",
    background: "#F8FAFC",
    border: `1px dashed ${theme.borderSoft}`,
    borderRadius: "14px",
    padding: "10px 14px",
    textAlign: "center",
    color: theme.textMuted,
    fontSize: "12px"
  };

  const emptyHierarchyCard = {
    padding: "18px",
    borderRadius: "18px",
    border: `1px dashed ${theme.borderSoft}`,
    color: theme.textMuted,
    background: "#F8FAFC",
    textAlign: "center"
  };

  const unassignedGrid = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "14px"
  };

  const unassignedCard = {
    padding: "14px 16px",
    borderRadius: "16px",
    background: "#FFF7ED",
    border: "1px solid #FED7AA"
  };

  const unassignedName = {
    fontSize: "14px",
    fontWeight: 700,
    color: theme.text
  };

  const unassignedMeta = {
    marginTop: "6px",
    fontSize: "12px",
    color: theme.textMuted
  };
  const inputWrapper = {
    position: "relative",
    width: "100%"
  };

  const modernInput = {
    width: "100%",
    padding: "16px",
    paddingRight: "110px",
    borderRadius: "16px",
    border: "1px solid #D7E2E0",
    fontSize: "15px",
    outline: "none",
    boxSizing: "border-box"
  };

  const inputTag = {
    position: "absolute",
    right: "16px",
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: "13px",
    color: "#94A3B8",
    fontWeight: 600,
    transition: "0.2s ease",
    pointerEvents: "none"
  };

  const resetOverlay = {
    position: "fixed",
    inset: 0,
    background: "rgba(15, 23, 42, 0.45)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    backdropFilter: "blur(6px)"
  };

  const resetModal = {
    width: "100%",
    maxWidth: "420px",
    background: "#FFFFFF",
    borderRadius: "28px",
    padding: "28px",
    boxShadow: "0 25px 60px rgba(15,23,42,0.25)",
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  };

  const resetTitle = {
    margin: 0,
    fontSize: "24px",
    fontWeight: 800,
    color: theme.text
  };

  const resetText = {
    margin: 0,
    color: theme.textMuted,
    fontSize: "15px",
    lineHeight: 1.6
  };

  const resetInput = {
    width: "100%",
    padding: "14px 16px",
    borderRadius: "16px",
    border: `1px solid ${theme.borderSoft}`,
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box"
  };

  const resetButtonRow = {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginTop: "8px"
  };

  const resetCancelBtn = {
    border: `1px solid ${theme.borderSoft}`,
    borderRadius: "14px",
    padding: "12px 18px",
    background: "#FFFFFF",
    color: theme.text,
    fontWeight: 700,
    cursor: "pointer"
  };

  const resetConfirmBtn = {
    border: "none",
    borderRadius: "14px",
    padding: "12px 18px",
    background: "linear-gradient(135deg, #0F766E, #14B8A6)",
    color: "#FFFFFF",
    fontWeight: 700,
    cursor: "pointer"
  };

  const resetMessageBox = {
    padding: "12px",
    borderRadius: "14px",
    background: "#F8FAFC",
    fontSize: "14px",
    fontWeight: 700
  };

  const passwordWrapper = {
    position: "relative",
    width: "100%"
  };

  const eyeBtn = {
    position: "absolute",
    right: "14px",
    top: "50%",
    transform: "translateY(-50%)",
    border: "none",
    background: "transparent",
    outline: "none",
    boxShadow: "none",
    cursor: "pointer",
    color: "#64748B",
    padding: 0,
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px"
  };

  export default AdminPanel;